export default "__VITE_ASSET__4f2cb213__"